import { OPTIMIZELY_PDF_PATH, OPTIMIZELY_URL } from ".";

export const supportedDocsMsg =
  "Supported formats are PDF, JPG, PNG, Word, EML, MP3, MP4, MSG and Excel with a maximum size of 5MB each.";
export const documentUnique = {
  AECB_Consent_Form_Company: "RODOC31",
  AECB_Consent_Signatory: "RODOC32",
  AECB_Consent_Shareholder: "RODOC33",
  AECB_Consent_Corporate_Guarantor: "RODOC34",
  AECB_Consent_Personal_Guarantor: "RODOC35",
  AECB_Consent_Co_Borrower: "RODOC36",
  Eum_Proof: "RODOC54",
  SignatoryInvolvementInBusiness: "RODOC55",
  SignatoryRecentColorPhotograph: "RODOC60",
  SponsorPassportVisa: "RODOC57",
  SponsorEmiratesId: "RODOC58",
  SponsorNOC: "RODOC59",
  CompanyTelephoneBill: "RODOC51",
  ProofOfOutsourceStaff: "RODOC53",
  InwardChequeProof: "RODOC61",
  OutwardChequeProof: "RODOC62",
  AdditionalSecurityDocuments: "RODOC63",
  SignBoardProof: "RODOC50",
  OtherCompanySignBoardProof: "RODOC52",
  InwardChequeTemplate: "RODOC64",
  OutwardChequeTemplate: "RODOC65"
};

export const downloadableDocs = ["DOC8", "DOC9"];

export const downloadableDocsData = {
  DOC8: {
    title: "Corporate Self-Certification Form (FATCA & CRS)",
    url: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}2-8-101120fatcacrscorporateallinone-editable.pdf`
  },
  DOC9: {
    title: "Standard declaration",
    url: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}standarddeclaration002.pdf`
  },
  RODOC63: {
    title: "Additional security",
    url: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}additionalsecuritytemplate.xlsx`
  },
  RODOC64: {
    title: "Inward cheques",
    url: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}inwardchequetemplate.xlsx`
  },
  RODOC65: {
    title: "Outward cheques",
    url: `${OPTIMIZELY_URL}${OPTIMIZELY_PDF_PATH}outwardchequetemplate.xlsx`
  }
};

/**
 * Document duplication mapping configuration
 * When a document with sourceUniqueId is uploaded/deleted,
 * the same operation is automatically applied to targetUniqueId
 *
 * @type {Object.<string, string>}
 * @example
 * // RODOC21 uploads will automatically duplicate to RODOC7
 * { "RODOC21": "RODOC7" }
 */
export const DOCUMENT_DUPLICATION_MAP = {
  RODOC21: "RODOC7"
};
